import { NewGridThemeKey } from "Components/AppGrid/shipeezi-new-grid";
import { BrandCustom } from "../models/brand.custom";

export const getBrandCustom = (color: keyof BrandCustom, defaultColor: string): string => {
  try {
    const brandCustomData = localStorage.getItem(NewGridThemeKey);
    if (!brandCustomData) return defaultColor;

    const brandCustom = JSON.parse(brandCustomData) as BrandCustom;

    return (brandCustom[color] as string) || defaultColor;
  } catch (error) {
    console.log("Error retrieving brand custom data:", error);
    return defaultColor;
  }
};
